import script from "./DealerTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./DealerTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./DealerTableWidget.vue?vue&type=style&index=0&id=7a8c7c52&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8c7c52"]])

export default __exports__